::ng-deep textarea{height:230px}
/*# sourceMappingURL=map-company.component-H47ZWNPM.css.map */
